function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { Chart } from 'chart.js';
import { scales, color_rose, color_blue } from "./ChartConfig";
export default function TileVisibilityChart(ctx, tileLayer) {
  var nbVisibleLabels = [];
  var nbVisibleData = [];
  var nbDisplayedData = [];
  var nbVisibleChart = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: nbVisibleLabels,
      datasets: [{
        label: 'Visible node per level',
        data: nbVisibleData,
        backgroundColor: color_rose
      }, {
        label: 'Diplayed node per level',
        data: nbDisplayedData,
        backgroundColor: color_blue
      }]
    },
    options: {
      scales: scales
    }
  });
  this.update = function (displayed) {
    function countVisible(node, stats) {
      if (!node || !node.visible) {
        return;
      }
      if (node.level >= 0 && node.layer === tileLayer) {
        if (stats[node.level]) {
          stats[node.level][0] += 1;
        } else {
          stats[node.level] = [1, 0];
        }
        if (node.material.visible) {
          stats[node.level][1] += 1;
        }
      }
      if (node.children) {
        var _iterator = _createForOfIteratorHelper(node.children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            countVisible(child, stats);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    // update bar graph
    var stats = {};
    countVisible(tileLayer.object3d, stats);
    nbVisibleLabels.length = 0;
    nbVisibleData.length = 0;
    for (var level in stats) {
      if ({}.hasOwnProperty.call(stats, level)) {
        nbVisibleLabels[level] = "".concat(level);
        nbVisibleData[level] = stats[level][0];
        nbDisplayedData[level] = stats[level][1];
      }
    }
    if (displayed) {
      nbVisibleChart.update();
    }
  };
  this.resize = function () {
    nbVisibleChart.resize();
  };
}